/** @jsxImportSource theme-ui */
import { Container, Box, Grid, Flex } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import Аctions from '@/containers/incentives/Actions';
import Button from '@/components/Button';

const ActionsPage = () => {
    let navigate = useNavigate();
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Flex sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => {
                            navigate('/actions/new');
                        }}
                    >
                        Add action
                    </Button>
                </Flex>

                <Box
                    sx={{
                        borderRadius: 'sm',
                        overflowY: 'scroll',
                        zIndex: 2,
                        justifySelf: 'left',
                        width: '100%',
                        backgroundColor: 'background',
                        padding: 2,
                        position: 'relative',
                    }}
                >
                    <Аctions />
                </Box>
            </Flex>
        </Container>
    );
};

export default ActionsPage;
